import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import { TypeOcr, TypeOcrH6 } from './Types';

// <audio controls  src="/quiet-symphony.mp3"></audio>;

// use mp3 for best compatibility

export interface AudioPlayerFile {
  name: string;
  src: string;
}

/*interface AudioPlayerProps extends AudioPlayerFile {
  index: number;
  toggle: () => void;
}*/
interface AudioPlayersProps {
  files: AudioPlayerFile[];
}

interface PlayButtonProps {
  name: string;
  playing: boolean;
  onClick: () => void;
}

function PlayButton(props: PlayButtonProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        noWrap: 'false',
        alignItems: 'center',
        height: 75,
        width: '100%',
        backgroundColor: 'success.main',
        borderRadius: 0,
        borderColor: 'info.main',
        border: 1,
      }}
    >
      <IconButton
        aria-label={!props.playing ? 'play' : 'pause'}
        onClick={props.onClick}
      >
        {!props.playing ? (
          <PlayCircleOutlineIcon
            sx={{ fontSize: '3rem', color: 'info.main' }}
          />
        ) : (
          <PauseCircleOutlineIcon
            sx={{ fontSize: '3rem', color: 'info.main' }}
          />
        )}
      </IconButton>
      <Divider
        style={{ width: 1 }}
        flexItem
        color='black'
        role='presentation'
        orientation='vertical'
      />

      <Box sx={{ width: 785 }}>
        <TypeOcr ml={1} fontSize={14}>
          <b>{props.name}</b>
        </TypeOcr>
      </Box>
    </Box>
  );
}

export default function AudioPlayers(props: AudioPlayersProps) {
  const [playIndex, setPlayIndex] = React.useState(-1);
  const idxs = Array.from({ length: props.files.length }, (x, i) => i);
  const audioRef = React.useRef<HTMLAudioElement>(null);

  const stateChange = async (newIndex: number) => {
    if (newIndex < 0 && audioRef.current) {
      await audioRef.current.pause();
    }

    if (newIndex >= 0 && audioRef.current) {
      const playSrc = newIndex < 0 ? '' : props.files[newIndex].src;

      if (audioRef.current.src !== playSrc || audioRef.current.paused) {
        audioRef.current.src = playSrc;
        await audioRef.current.play();
      }
    }

    setPlayIndex(newIndex);
  };

  return (
    <>
      <TypeOcrH6 mt={3}>Sounds for your earholes</TypeOcrH6>
      <Grid container style={{ alignItems: 'center' }} spacing={2}>
        {idxs.map((i: number) => (
          <Grid
            key={props.files[i].name}
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{
              my: { xs: 1 },
            }}
          >
            <PlayButton
              name={props.files[i].name}
              key={props.files[i].name}
              playing={i === playIndex}
              onClick={() => {
                stateChange(playIndex === i ? -1 : i);
              }}
            />
          </Grid>
        ))}
        <audio ref={audioRef} src='' loop={true}>
          Audio player not supported in this browser. Here is a
          <a href='file.mp3'>link to the audio</a> instead.
        </audio>
      </Grid>
    </>
  );
}
